import HeroSection from "../components/Home/HeroSection"
import Cards from "./home/Cards"

export const Home = () => {
    return (
        <>
            <HeroSection/>
            <Cards/>
        </>
    )
}